import React from 'react';
import PropTypes from 'prop-types';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { notificationApi } from '@bingads-webui-campaign/notification-center';
import { shellTips } from '@bingads-webui-campaign-react/shell-ui-common';

export const WithCampaignCriterionRepository = ({
  WrappedComponent, i18n,
}) => (
  <CampaignOData
    call={({ currentCampaign }) => currentCampaign.CampaignCriterions.$cast('Model.CampaignCriterion').get({
          filter: { where: "isof(Criterion,'Model.LocationCriterion') or isof(Criterion,'Model.RadiusCriterion') or isof(Criterion,'Model.DeviceCriterion')" },
      })
    }
    escapeHatch={({ currentCampaign }) => (currentCampaign ? undefined : null)}
    fallback={(<WrappedComponent campaignCriterionFromOData={{ dataNotReady: true }} />)}
    onError={() => {
      notificationApi.showWarning(i18n.getString(shellTips.shellDataError));
      return (<WrappedComponent campaignCriterionFromOData={{ dataNotReady: true }} />);
    }}
  >
    { campaignCriterionFromOData =>
      (<WrappedComponent campaignCriterionFromOData={campaignCriterionFromOData} />) }
  </CampaignOData>
);

WithCampaignCriterionRepository.propTypes = {
  WrappedComponent: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
